export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const CREATE_CUSTOMER_FULFILLED = 'CREATE_CUSTOMER_FULFILLED';
export const CREATE_CUSTOMER_REJECTED = 'CREATE_CUSTOMER_REJECTED';
